
/* cap the calibration slider to the space the panel actually has — the card can then
   never grow past the sheet edge (mm input remains for screens smaller than a card) */
(function(){
  var cal=document.getElementById('sjw-sg-calib'),sl=document.getElementById('sjw-sg-card-slider');
  if(!cal||!sl)return;
  function cap(){
    if(!cal.clientWidth)return;
    var mx=Math.min(560,cal.clientWidth-30);
    if(mx<220)mx=220;
    sl.max=mx;
    if(parseFloat(sl.value)>mx){sl.value=mx;try{sl.dispatchEvent(new Event('input',{bubbles:true}))}catch(e){}}
  }
  try{new MutationObserver(cap).observe(cal,{attributes:true,attributeFilter:['style']});}catch(e){}
  window.addEventListener('resize',cap,{passive:true});
  cap();
})();
